module.exports = __webpack_public_path__ + "static/media/Apple – 1.2861e1a9.jpg";